import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from 'src/hooks/useUser';

const SYSTEM_AGENT_PREFIXES = ['watchlist', 'recommendation'] as const;
export type SystemAgentPrefix = (typeof SYSTEM_AGENT_PREFIXES)[number];

export function getSystemAgentName(prefix: SystemAgentPrefix, authProvider: string, userId: string): string {
  return `${prefix}-${authProvider}-${userId}`;
}

export function isSystemAgent(displayName: string | undefined, authProvider: string, userId: string): boolean {
  return SYSTEM_AGENT_PREFIXES.some((p) => displayName === getSystemAgentName(p, authProvider, userId));
}

export function useSystemAgentLabel(): (name: string) => string {
  const { t } = useTranslation();
  const { data: user } = useUser();
  const authProvider = user?.user?.authenticationProvider ?? '';
  const userId = user?.user?.id ?? '';
  const watchlistName = getSystemAgentName('watchlist', authProvider, userId);
  const recommendationName = getSystemAgentName('recommendation', authProvider, userId);

  return useCallback(
    (name: string) => {
      if (name === watchlistName) return t('watchlist.watchlist');
      if (name === recommendationName) return t('recommendationsPage.title');
      return name;
    },
    [watchlistName, recommendationName, t],
  );
}
